<template>
    <div style="background: #FAFAFA;">
        <div style="padding-bottom: 40px; padding-top: 0.5rem">
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>
            <div class="container top-spot mt-5" v-if="challenge">
                <h5 @click="goBack()"><span><i class="fa fa-chevron-left"></i></span>{{challenge.challenge_category.name}}</h5>
            </div>
            <div v-if="challenge">
                <img class="w-100" :src="challenge.imageURL" alt="art">
            </div>

            <div class=" container number_counter" v-if="challengeOutter">
                <div class="row">
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="count-item">
                                    <h5>Current Votes</h5>
                                    <h2>0000000</h2>
                                </div>
                            </div>
                            <div class="col-6">
                                <div  class="count-item">
                                    <h5>Leaderboard Rank</h5>
                                    <h2>{{ challengeOutter.position }}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" v-if="challenge">
                <h6 class="week-challenge-text">{{challenge.cohort}} Challenge</h6>
                <div class="challenge-body">
                    <h1>{{ challenge.title }}</h1>
                    <h6>{{ challenge.details }}</h6>
                    <p class="no-submission" v-if="!challengeOutter.submitted">
                        <span class="dot"></span>
                       No Submission
                    </p>
                    <p class="submission" v-if="challengeOutter.submitted">
                        <span class="dot"></span>
                       Submitted
                    </p>
                </div>

                <div class="days-left">
                     <h4> <span>🗓️</span> 3 days left till submission</h4>
                </div>

                <div class="participant-group">
                    <!-- <div class="avatar-group">
                        <img src="../../assets/images/ray-team.svg" alt="">
                        <img src="../../assets/images/ray-team.svg" alt="">
                        <img src="../../assets/images/ray-team.svg" alt="">
                        <img src="../../assets/images/ray-team.svg" alt="">
                        <img src="../../assets/images/ray-team.svg" alt="">
                    </div> -->
                    <h5>{{ challengeOutter.participants }} Participants</h5>
                </div>

                <div class="task-holder">
                    <h3>Task</h3>
                    <ul>
                        <li v-html="challenge.guide_lines_with_html"></li>
                    </ul>
                </div>

                <div class="submission-btn mt-5 d-block"  v-if="!challengeOutter.submitted">
                    <button class="btn sub btn-responsive" @click="routeTo(`/dashboard/upload-challenge/${challengeid}`)">Submit</button>
                </div>

                <div v-else class="submission-btn mt-1 d-block">
                    <button class="btn sub btn-responsive" @click="goToSubmission()">View Submission</button>
                </div>
                
                <!-- <div class="submission-btn mt-3">
                    <button class="btn view btn-responsive">View Submission</button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "ViewChallenge",
    components: {
        PageLoader
    },

    data() {
        return {
            loading: false,
            challenge: null,
            challengeOutter: null,
            challengeid: null,
        };
    },
    mounted() {
        this.fetchChallengeDetails();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        goToSubmission() {
            // Save to localStorage so it persists on refresh
            localStorage.setItem('kidSubmission', JSON.stringify(this.challengeOutter));
            this.$router.push({ path: '/dashboard/submissions' });
        },
        async fetchChallengeDetails() {
            this.loading = true;
            this.challengeid = this.$route.params.id;
            const kidId = this.$route.params.kidId
            try {
                // fetch-super-kids-challenge-by-id
        await Api.getRequest(`fetch-super-kids-challenge-by-id-and-kid-id/${this.challengeid}/${kidId}`).then(res => {
                if (res.data.success) {
                    this.loading = false;
                    console.log("challenges details", res);
                    this.challenge = res.data.data;
                    this.challengeOutter  = res.data;
                   const imageLibrary = {
                        1: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772793749/cp1_fnkzos.svg",
                        2: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609898/center-super-speaches_vigfx1.svg",
                        3: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609897/center-mother-tongue_cyigmd.svg",
                        4: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609898/center-music_aqcwi2.svg",
                        5: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609899/center-dance_hwrxwu.svg",
                        6: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609899/center-foreign-language_tgjpd5.svg",
                        7: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609989/center-stem_fennhs.svg",
                        8: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1774609991/center-abilities_bcqsnq.svg"
                    };

                    // this.challenge = this.challenge.map(item => ({
                    //     ...item,
                    //     // It looks for the URL by ID; if not found, it uses a placeholder
                    //     imageUrl: imageLibrary[item.category_id] || "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772111385/Challenge_card_small_whqefx.svg"
                    // }));

                    if (imageLibrary[this.challenge.category_id]) {
                        this.challenge.imageURL = imageLibrary[Number(this.challenge.category_id)];
                    }
                    console.log("challenges details2", res);
                }
                }).catch(err => {
                    console.log("err:", err)
                    this.loading = false;
                })
            } finally {
                // console.log("closed")
            }
        },
    }
};
</script>

<style lang="scss" scoped>

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}

.week-challenge-text {
    font-family: Nunito;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    color: #1C2B3A;
    text-align: left;
    margin-top: 20px;
}

.number_counter {
    margin-top: 40px;
    margin-bottom: 40px;
}
.count-item {
    border: 1px solid #F5F7FA;
    background: #ffffff;
    border-radius: 20px;
    padding: 12px 16px;
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: left;
        margin-bottom: 15px;
    }
    h2 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 28px;
        color: #1C2B3A;
        line-height: 100%;
        text-align: left;
    }
}

.challenge-body {
    h1 {
        font-family: Nunito;
        font-weight: 800;
        font-size: 22.38px;
        line-height: 28px;
        color: #1C2B3A;
        text-align: left;
        margin-top: 20px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        text-align: left;
        font-size: 18px;
        line-height: 28px;
        color: #1C2B3A;
    }
    .no-submission {
        background: #D1EFFA;
        border-radius: 50px;
        padding: 9px 22px;
        border: 2px solid #FFFFFF;
        box-shadow: 0px 0px 1.4px 3px #5D6F7C0D inset;
        margin-top: 30px;
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        color: #2AB3E6;
        height: 36px;
        width: fit-content;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        .dot {
            width: 10px;
            height: 10px;
            background: #2AB3E6;
            // color: white;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            margin-right: 8px;
        }
    }
    .submission {
        background: #CCFFE1;
        border-radius: 50px;
        padding: 9px 22px;
        border: 2px solid #FFFFFF;
        box-shadow: 0px 0px 1.4px 3px #5D6F7C0D inset;
        margin-top: 30px;
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        color: #00C853;
        height: 36px;
        width: fit-content;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        .dot {
            width: 10px;
            height: 10px;
            background: #00C853;
            // color: white;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            margin-right: 8px;
        }
    }
}


.days-left {
    margin-top: 30px;
    h4 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #1C2B3A;
        text-align: left;
    }
}


.avatar-group {
  display: flex;
  align-items: center;
}


.participant-group {
    margin-top: 25px;
    display: flex;
    align-items: center;
    h5 {
        margin-left: 10px;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #1C2B3A;
        text-align: left;
        white-space: nowrap;
    }
}
.avatar-group img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff; /* creates separation */
  position: relative;
}

.avatar-group img:not(:first-child) {
  margin-left: -20px; /* ~15% overlap */
}

.avatar-group img {
  position: relative;
}

.task-holder {
    margin-top: 30px;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        text-align: left;
        color: #1C2B3A;

    }
    ul {
        padding-left: 20px;
        li {
            font-family: Lato;
            font-weight: 400;
            font-size: 18px;
            line-height: 20px;
            color: #1C2B3A;
            text-align: left;
        }
    }

}

.avatar-group img:nth-child(1) { z-index: 4; }
.avatar-group img:nth-child(2) { z-index: 3; }
.avatar-group img:nth-child(3) { z-index: 2; }
.avatar-group img:nth-child(4) { z-index: 1; }

.submission-btn {
    button {
        background: #2AB3E6;
        color: #ffffff;
        font-family: Lato;
        font-weight: 400;
        font-size: 18px;
        line-height: 100%;
        color: #ffffff;
        border-radius: 50px;
        height: 45px;
        outline: 0;
        box-shadow: none;
    }
}

.btn-responsive {
  width: 100%;
}

@media (min-width: 992px) {
  .btn-responsive {
    width: 50%;
  }
}
</style>

